import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { BillFindManyQueryInterface } from '@zaoblako/shared/modules/document/dtos/bill/bill-find-many-query.dto';
import { BillPageInterface } from '@zaoblako/shared/modules/document/dtos/bill/bill-page.dto';
import { BillStatisticsInterface } from '@zaoblako/shared/modules/document/dtos/bill/bill-statistics.dto';
import type { BillVerifyQueryInterface } from '@zaoblako/shared/modules/document/dtos/bill-verify/bill-verify-query.dto';
import type { BillVerifyResultInterface } from '@zaoblako/shared/modules/document/dtos/bill-verify/bill-verify-result.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentBillService extends BaseService {
  protected baseUrl = '/finance/document/bill';

  public findWithPagination(queryParams: BillFindManyQueryInterface): Observable<BillPageInterface> {
    return this.http.get<BillPageInterface>(this.baseUrl, { params: this.objectToHttpParams(queryParams) });
  }

  public getRegistryDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(`${this.baseUrl}/registry-descriptor`);
  }

  public getVerifyRegistryDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(`${this.baseUrl}/verify-registry-descriptor`);
  }

  public autocheck(queryParams: BillVerifyQueryInterface): Observable<BillVerifyResultInterface> {
    return this.http.get<BillVerifyResultInterface>(`${this.baseUrl}/verify`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getDebtorsBillsPdf(id: number): Observable<BlobPart> {
    return this.http.get<BlobPart>(`${this.baseUrl}/${id}/download`, {
      responseType: 'arraybuffer' as any
    });
  }

  public statistics(queryParams: BillFindManyQueryInterface): Observable<BillStatisticsInterface> {
    return this.http.get<BillStatisticsInterface>(`${this.baseUrl}/statistics`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
